import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { TEXT } from "../constants";

export const ProcessingContent: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={300}
      py={4}
    >
      <Stack spacing={3} alignItems="center">
        <CircularProgress size={60} thickness={4} />

        <Typography variant="h6" color="text.primary">
          {TEXT.PROCESSING_TITLE}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {TEXT.PROCESSING_SUBTITLE}
        </Typography>
      </Stack>
    </Box>
  );
};
